import Api from '../api';

const apiInstance = Api.getInstance();

export const getSubscriptionList = (gamerId, socialUin) => {
  return apiInstance.get(`/subscriptions/${socialUin}?gamerId=${gamerId}`, false, '');
};
